import { render } from "./SelectBank.vue?vue&type=template&id=876bd000"
import script from "./SelectBank.vue?vue&type=script&lang=js"
export * from "./SelectBank.vue?vue&type=script&lang=js"

import "./SelectBank.vue?vue&type=style&index=0&id=876bd000&lang=css"
script.render = render

export default script